import 'react-sortable-tree/style.css';

import ITreeViewItem from '@interfaces/ITreeViewItem';
import I18n from '@src/i18n';
import styled, { Theme } from '@src/styled-components';
import { Avatar, Button, Icon, Tooltip, Tree } from 'antd';
import findIndex from 'lodash/findIndex';
import * as React from 'react';

import { TreeViewItemInputsComponent } from './TreeViewItemInputs';
import uuidv4 from 'uuidv4'

export interface ITreeViewItemProps {
    onChangeTree?: (treeViewItems: ITreeViewItem[]) => void;
    data: ITreeViewItem[];
    externalValidation?: (isOk: boolean) => void;
}

export interface ITreeViewItemState {
    treeData: TreeStructureItem[];
    createInsideAnother: boolean;
    expandedKeys: string[];
}



class TreeStructureItem {
    private key: string;
    private children: TreeStructureItem[];

    /**
     * 
     * @param key identifier key
     * @param title content
     * @param children children that will appear when item expanded
     */
    constructor(key: string, title: string | React.ReactNode, children?: TreeStructureItem[]) {
        this.key = key;
        this.title = title;
        this.children = children ? children : [];


        return this;
    }

    public getKey(): string {
        return this.key;
    }
    public getChildren(): TreeStructureItem[] {
        return this.children;
    }

    public setChildren(items: TreeStructureItem[]) {
        this.children = items;
    }
}

class TreeItemData {
    value: string;
    points: string;
    depth: number;

    constructor(value: string, points: string, depth: number) {
        this.value = value;
        this.points = points;
        this.depth = depth;
    }
}

const { TreeNode } = Tree;

let inputItemsValidator: Function[] = [];


export default class TreeViewComponent extends React.Component<ITreeViewItemProps, ITreeViewItemState> {
    private TreeItemsDictionary = new Map<string, TreeItemData>();

    constructor(props: ITreeViewItemProps) {
        super(props);

        this.state = {
            treeData: [],
            createInsideAnother: false,
            expandedKeys: [],
        }
        this.handleAddNew = this.handleAddNew.bind(this);
        this.handleModalCheckboxChanged = this.handleModalCheckboxChanged.bind(this);
        this.handleRemoveListItem = this.handleRemoveListItem.bind(this);
        this.onChangeValueField = this.onChangeValueField.bind(this);
        this.onChangePointsField = this.onChangePointsField.bind(this);
        this.addValidator = this.addValidator.bind(this);
        this.validateData = this.validateData.bind(this);
        this.getTreeData = this.getTreeData.bind(this);
        this.onExpand = this.onExpand.bind(this);
    }

    componentDidMount() {

    }

    UNSAFE_componentWillReceiveProps(props: ITreeViewItemProps) {
        if (this.props.data != props.data) {
            this.formatApiDataToTree(props.data);           
        }
    }

    formatApiDataToTree(data: ITreeViewItem[]) {
        let dataExtracted: TreeStructureItem[] = [];

        let dataToExtract: ITreeViewItem[] = [];
        if (data && data.length > 0) {
            dataToExtract = data;
        }
        else {
            dataToExtract = [{
                value: '',
                depth: 0,
                weight: 0
            }];
        }

        dataExtracted = this.extractApiData(dataToExtract, 0, 0);
        this.setState({ treeData: dataExtracted });
    }

    extractApiData(data: ITreeViewItem[], startIndex: number, depth: number) {
        // const { data } = this.props;
        let newData: TreeStructureItem[] = [];

        for (let i = startIndex; i < data.length; i++) {
            if (data[i]) {

                if (data[i].depth < depth) {
                    return newData;
                }
                const key = `tree-item-${i}`;
                if (data[i].depth === depth) {
                    const value: string = data[i].value != undefined ? data[i].value : '';

                    const points: string = data[i].weight != undefined ? (data[i].weight).toLocaleString() : '';

                    const title =
                        (<div key={`inputgroup-${key}`}>
                            <TreeViewItemInputsComponent
                                componentKey={key}
                                valueInputDefaultValue={value}
                                pointsInputDefaultValue={points}
                                onRemoveItem={this.handleRemoveListItem}
                                onChangeValueField={this.onChangeValueField}
                                onChangePointsField={this.onChangePointsField}
                                externalValidator={this.addValidator}
                                showDraggablePart />
                        </div>);

                    const newItem = new TreeStructureItem(key, title);

                    const itemData: TreeItemData = new TreeItemData(value, points, depth);

                    if (data[i + 1]) {
                        if (data[i + 1].depth === depth + 1) {
                            newItem.setChildren(this.extractApiData(data, i + 1, depth + 1))
                        }
                    }
                    newData.push(newItem);
                    this.TreeItemsDictionary.set(key, itemData);
                }
            }
        }
        return newData;
    }

    async handleAddNew() {
        const { treeData } = this.state;
        let newTreeData: TreeStructureItem[];

        newTreeData = [...treeData];

        const key = uuidv4();

        newTreeData.push(new TreeStructureItem(
            key,
            <TreeViewItemInputsComponent
                componentKey={key}
                onRemoveItem={this.handleRemoveListItem}
                onChangeValueField={this.onChangeValueField}
                onChangePointsField={this.onChangePointsField}
                externalValidator={this.addValidator}
                showDraggablePart />,
            []
        ));

        const itemData: TreeItemData = new TreeItemData('', '', 0);
        this.TreeItemsDictionary.set(key, itemData);
        await this.setState({ treeData: newTreeData });

        this.updateListTreeToParent();
    }

    onChangeValueField(itemId: string, value: string) {
        let itemData: TreeItemData = this.TreeItemsDictionary.get(itemId);
        if (itemData) {
            this.TreeItemsDictionary.set(itemId, new TreeItemData(value, itemData.points, itemData.depth));
        }
        this.updateListTreeToParent();
    }

    onChangePointsField(itemId: string, value: string) {
        let itemData: TreeItemData = this.TreeItemsDictionary.get(itemId);
        if (itemData) {
            this.TreeItemsDictionary.set(itemId, new TreeItemData(itemData.value, value, itemData.depth));
        }
        this.updateListTreeToParent();
    }

    extractTreeDataToApi(items: TreeStructureItem[], actualDepth?: number): ITreeViewItem[] {
        let depth: number = actualDepth || 0;
        let returnItems: ITreeViewItem[] = [];

        for (let item of items) {
            const itemData: TreeItemData = this.TreeItemsDictionary.get(item.getKey());
            if (itemData) {
                returnItems.push({
                    value: itemData.value,
                    depth: depth,
                    weight: itemData.points ? parseInt(itemData.points) : 0
                });
            }
            if (item.getChildren() && item.getChildren().length > 0) {
                returnItems = returnItems.concat(this.extractTreeDataToApi(item.getChildren(), depth + 1));
            }
        }

        return returnItems;
    }

    handleModalCheckboxChanged(e: any) {
        this.setState({ createInsideAnother: e.target.checked })
    }

    handleRemoveListItem(key: string) {
        const newData = this.findAndRemoveTreeItem(key, this.state.treeData);
        this.setState({ treeData: newData });
    }

    updateListTreeToParent() {
        if (this.props.onChangeTree) {
            this.props.onChangeTree(this.extractTreeDataToApi(this.state.treeData, 0))
        }
    }

    findAndRemoveTreeItem(key: string, items: TreeStructureItem[]) {
        let auxItems: TreeStructureItem[] = [...items];

        let index = findIndex(
            auxItems,
            (i: TreeStructureItem) => i.getKey() === key
        );

        if (index !== -1) {
            auxItems.splice(index, 1);
            return auxItems;
        }

        auxItems.forEach((treeItem, i) => {
            if (treeItem.getChildren() && treeItem.getChildren().length > 0) {
                const ret = this.findAndRemoveTreeItem(key, treeItem.getChildren());
                treeItem.setChildren(ret);
            }
        });

        return auxItems;
    }

    onDrop = async (info: any) => {
        const dropKey = info.node.props.eventKey;
        const dragKey = info.dragNode.props.eventKey;
        const dropPos = info.node.props.pos.split('-');
        const dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1]);

        const loop = (data: any, key: any, callback: any) => {
            data.forEach((item: any, index: any, arr: any) => {
                if (item.key === key) {
                    return callback(item, index, arr);
                }
                if (item.children) {
                    return loop(item.children, key, callback);
                }
            });
        };
        const data = [...this.state.treeData];

        // Find dragObject
        let dragObj: any;
        loop(data, dragKey, (item: any, index: any, arr: any) => {
            arr.splice(index, 1);
            dragObj = item;
        });

        if (!info.dropToGap) {
            // Drop on the content
            loop(data, dropKey, (item: any) => {
                item.children = item.children || [];
                // where to insert 示例添加到尾部，可以是随意位置
                item.children.push(dragObj);
            });
        } else if (
            (info.node.props.children || []).length > 0 // Has children
            && info.node.props.expanded // Is expanded
            && dropPosition === 1 // On the bottom gap
        ) {
            loop(data, dropKey, (item: any) => {
                item.children = item.children || [];
                // where to insert 示例添加到尾部，可以是随意位置
                item.children.unshift(dragObj);
            });
        } else {
            let ar;
            let i;
            loop(data, dropKey, (item: any, index: any, arr: any) => {
                ar = arr;
                i = index;
            });
            if (dropPosition === -1) {
                ar.splice(i, 0, dragObj);
            } else {
                ar.splice(i + 1, 0, dragObj);
            }
        }
        await this.setState({
            treeData: data,
        });

        if (this.props.onChangeTree) {
            this.props.onChangeTree(this.extractTreeDataToApi(this.state.treeData, 0))
        }
    }

    onExpand(expandedKeys: string[], expanded: any) {
        this.setState({ expandedKeys });
    }

    addValidator(itemValidator: Function) {
        const validators = inputItemsValidator.concat(itemValidator);
        inputItemsValidator = validators;
    }

    validateData() {
        let validationOk: boolean = true;
        for (let validator of inputItemsValidator) {
            let validateValue = validator();
            if (!validateValue) {
                validationOk = false;
                if (this.props.externalValidation) { this.props.externalValidation(false) }
            }
        }
        if (this.props.externalValidation) { this.props.externalValidation(true) }
        return validationOk;
    }

    expandAll() {
        let newExpandedKeys: string[] = [];
        for (let key of this.TreeItemsDictionary.keys()) {
            newExpandedKeys.push(key);
        }
        this.setState({ expandedKeys: newExpandedKeys });
    }

    getTreeData() {
        return this.extractTreeDataToApi(this.state.treeData);
    }


    render() {
        const loop = (data: TreeStructureItem[]) => data.map((item: any) => {
            if (item.children && item.children.length) {
                return <TreeNode key={item.key} title={item.title}>{loop(item.children)}</TreeNode>;
            }
            return <TreeNode key={item.key} title={item.title} />;
        });

        return (
            <React.Fragment>
                <Wrapper>
                    <TreeWrapper>
                        <Tree
                            className="draggable-tree"
                            draggable
                            defaultExpandAll
                            showLine
                            multiple={false}
                            onDrop={this.onDrop}
                            onExpand={this.onExpand}
                            expandedKeys={this.state.expandedKeys}
                        >
                            {loop(this.state.treeData)}
                        </Tree>

                        <div className="tooltip-wrapper">
                            <Tooltip placement="right" title={I18n.l('formflow.components.selectComponent.scoreTooltipHelp')}>
                                <Avatar icon="question" />
                            </Tooltip>
                        </div>
                    </TreeWrapper>
                    <Button onClick={this.handleAddNew} className="goepik-btn-border-main add-item-btn">
                        <Icon type="plus" /> {I18n.l("formflow.buttons.createNewItemSepectComponent").toUpperCase()}
                    </Button>
                </Wrapper>
            </React.Fragment>
        );
    }
}

const Wrapper = styled.div`
    height: auto;
    display: flex;
    flex-flow: column;
    z-index: 9999;
        
    .ant-avatar{
        background: #fff;
        color: ${Theme.secondary.midGrey};
        border-color: ${Theme.primary.regular};
        border-width: 1px;
        border-style: solid;
        font-weight: bolder;
        display:flex;
        justify-content:center;
        align-items:center;
        width: 26px;
        height: 26px;
    }
        
    .add-item-btn{
        width: fit-content;
    }
`

const TreeWrapper = styled.div`
    display:flex;
    flex-flow: row;
    margin-bottom: 20px;

    .li {
        margin-bottom: 15px;   
    }

    .tree-wrapper{
        width: 100px;
        height: 100px;
    }

    .ant-tree li .ant-tree-node-content-wrapper{
        margin-bottom:2px;
        height: auto;
    }

    .ant-tree li .ant-tree-node-content-wrapper.ant-tree-node-selected{
        height: auto;
    }

    .ant-tree.ant-tree-show-line li span.ant-tree-switcher{
        margin-top: 10px;
    }

`
